import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const SAMPLE_AGS_DEMOS = [{
  boundaryGroupId: 4061, // ags us counties
  demographicId: 'AGS_US_COUNTIES_AGE_INCOME_HINCYA6512',
}, {
  boundaryGroupId: 4061,
  demographicId: 'AGS_US_COUNTIES_INCOME_HIXCY25050',
}] as const;

export const isDataLayersArtificialBoundaryTerritoryGroup = (boundaryTerritoryGroup: BoundaryTerritoryGroup): boolean => {
  return boundaryTerritoryGroup.boundaryTerritoryGroupId < 0;
};
